import React from 'react'
import {Image, Layer, Stage} from "react-konva";
import useImage from "use-image";

const URLImage = ({image}) => {
    const defaultSize = 100;
    let height = 100;
    let width = 100;
    let ratio = 1;

    const [img] = useImage(image.src);

    if (img) {
        console.log('img.width: ', img.width);
        console.log('img.height: ', img.height);

        if (img.width > img.height) {
            ratio = img.width / img.height;
        } else {
            ratio = img.height / img.width;
        }

        console.log('ratio: ', ratio);
        height = height * ratio;
        width = width * ratio;
    }

    return (
        <Image
            image={img}
            x={image.x}
            y={image.y}
            width={width}
            height={height}
            // I will use offset to set origin to the center of the image
            offsetX={50}
            offsetY={50}
            // offsetX={img ? img.width / 2 : 0}
            // offsetY={img ? img.height / 2 : 0}
            draggable={true}
        />
    );
};

const DragDropImage = () => {
    const dragUrl = React.useRef();
    const stageRef = React.useRef(null);
    const [images, setImages] = React.useState([]);

    const handleDragStart = (event) => {
        dragUrl.current = event.target.src;
    }

    const handleDragOver = (event) => {
        event.preventDefault();
    }

    const handleDropEnd = (event) => {
        event.preventDefault();
        // register event position
        // @ts-ignore
        stageRef.current.setPointersPositions(event);
        const pointerPosition = stageRef.current.getPointerPosition();
        console.log('pointerPosition: ', pointerPosition);

        // add image
        // @ts-ignore
        setImages(
            images.concat([
                {
                    ...pointerPosition,
                    src: dragUrl.current,
                },
            ])
        );
    }

    return (
        <>
            <div>
                Try to drag and image into the stage:
                <br/>
                <img
                    width={100}
                    alt="lion"
                    src={"../../assets/images/background/space-splash001.png"}
                    draggable={true}
                    onDragStart={(e) => {
                        // @ts-ignore
                        dragUrl.current = e.target.src;
                    }}
                />
                <img
                    width={100}
                    alt="lion"
                    src={"../../assets/images/background/set_of_eco_or_go_green_icons_with_doodle_style.jpg"}
                    draggable={true}
                    onDragStart={handleDragStart}
                />
                <div
                    onDrop={handleDropEnd}
                    onDragOver={handleDragOver}>
                    <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                           className="bg-gray-200"
                           draggable
                           ref={stageRef}>
                        <Layer>
                            {images.map((image, index) => {
                                return <URLImage key={index} image={image}/>;
                            })}
                        </Layer>
                    </Stage>

                </div>
            </div>
        </>
    )
}

export default DragDropImage
